import { RootState } from "@/store/Store";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface TicketStatusesInterface {
    formVisible: boolean,
    formVariant: "new" | "edit",
    deleteStatusModalVisible: boolean,
}

function getInitialState(): TicketStatusesInterface {
    return {
        formVisible: false,
        formVariant: "new",
        deleteStatusModalVisible: false,
    }
}

export const TicketStatusesSlice = createSlice({
    name: "TicketStatusesSlice",
    initialState: getInitialState(),
    reducers: {
        changeFormVisibility: (state: TicketStatusesInterface, action: PayloadAction<TicketStatusesInterface["formVisible"]>) => {
            state.formVisible = action.payload;
        },
        changeFormVariant: (state: TicketStatusesInterface, action: PayloadAction<TicketStatusesInterface["formVariant"]>) => {
            state.formVariant = action.payload;
        },
        reset: (state: TicketStatusesInterface, action: PayloadAction<void>) => {
            const initialState = getInitialState();
            state.formVisible = initialState.formVisible;
            state.formVariant = initialState.formVariant;
            state.deleteStatusModalVisible = initialState.deleteStatusModalVisible;
        },
        changeDeleteModalVisibility: (state: TicketStatusesInterface, action: PayloadAction<TicketStatusesInterface["deleteStatusModalVisible"]>) => {
            state.deleteStatusModalVisible = action.payload;
        },
    },
});

export const {
    changeFormVisibility,
    changeFormVariant,
    reset,
    changeDeleteModalVisibility,
} = TicketStatusesSlice.actions;

export const getSelectorForValue = (name: keyof TicketStatusesInterface) => (state: RootState) => state.ticketStatuses[name];

export const TicketStatusesReducer = TicketStatusesSlice.reducer;
